import * as React from 'react';
import { connect } from 'react-redux';
import { IAppState, Dispatch } from '../../../../common/state';
import { EPlacementType } from '../../../../json_query';
import { getTermsValue } from '../../../../json_query/reducers/helpers';
import { pushTermsValue, removeTermsValue } from '../../../state/advanced/terms';
import { Row } from '../markup';
import { ButtonCheckboxList } from './button_checkbox_list';

interface IPlacementTypeProps {
  selected: EPlacementType[];
  select(placementType: EPlacementType): void;
  deselect(placementType: EPlacementType): void;
}

const placementTypes = [
  { title: 'Street retail', value: EPlacementType.StreetRetail },
  { title: 'В торговом комплексе', value: EPlacementType.ShoppingMall },
];

class PlacementTypeComponent extends React.PureComponent<IPlacementTypeProps> {
  public render() {
    const { deselect, selected, select } = this.props;

    return (
      <Row title="Тип помещения">
        <ButtonCheckboxList deselect={deselect} list={placementTypes} select={select} selected={selected} />
      </Row>
    );
  }
}

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    selected: getTermsValue('placement_type')(state.filters.jsonQuery),
  }),
  (dispatch: Dispatch) => ({
    select: (placementType: EPlacementType) => {
      dispatch(pushTermsValue('placement_type')(placementType));
    },
    deselect: (placementType: EPlacementType) => {
      dispatch(removeTermsValue('placement_type')(placementType));
    },
  }),
)(PlacementTypeComponent);
